import React from 'react';
import styled from 'styled-components';
import { Link } from '../components/text';

import Section from '../components/section';
import { stylesFor } from '../styles/utilities';

const Root = styled(Section)`
  && {
    align-items: flex-start;
    background: ${props => props.theme.color.white};
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-bottom: 0;
    position: relative;
    width: 100%;
  }
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  ${stylesFor.xLargeUp`
    flex-direction: row;
  `};
`;

const TextWrapper = styled.div`
  flex-basis: 0;
  flex-grow: 2;
  margin-bottom: 52px;

  ${stylesFor.smallUp`
    padding-bottom: 100px;
  `};

  ${stylesFor.xLargeUp`
    padding-right: 120px;
    padding-bottom: 0px;
  `};
`;

const Tagline = styled.div`
  color: ${props => props.theme.color.gray19};
  font-size: 24px;
  font-weight: ${props => props.theme.font.weight.bold};
  line-height: 1.25;
  margin-bottom: 28px;

  ${stylesFor.smallUp`
    font-size: 48px;
    margin-bottom: 52px;
  `};
`;

const Subtext = styled.p`
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 8px 0;
  max-width: 40rem;

  ${stylesFor.mediumUp`
    font-size: 16px;
  `};

  ${stylesFor.xLargeUp`
    font-size: 18px;
  `};
`;

const IllustrationWrapper = styled.div`
  flex-basis: 0;
  flex-grow: 3;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export default () => {
  return (
    <Root>
      <Content>
        <TextWrapper>
          <Tagline>
            Design beautiful and performant sites, pages, and web parts with
            SharePoint in Microsoft 365.
          </Tagline>
          <Subtext>
            Get inspired. Discover the modern experiences you can build with
            SharePoint in Microsoft 365.
          </Subtext>
          <Link href="https://aka.ms/sharepointlookbook">
            View SharePoint Look Book
          </Link>
        </TextWrapper>
        <IllustrationWrapper>
          <img src="images/illustration.png?v=1" width="720" height="648" />
        </IllustrationWrapper>
      </Content>
    </Root>
  );
};



// WEBPACK FOOTER //
// ./src/sections/intro.js